const createUrl = (val: string) => {
  console.log("Testing ::::: ", val);
  // remove punctuation marks from the string
  const removePunctuation = val.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "");

  console.log("Testing ::::: ", removePunctuation);
};

export default createUrl;
